import MainPage from "./lucky-draw";
import LuckyDrawParticipantPage from "./lucky-draw-participant"
import LiveDrawPage from "./live-draw"

export { MainPage, LuckyDrawParticipantPage, LiveDrawPage };
